import React from 'react';
import { Info } from 'lucide-react';

/**
 * BlogDisclaimer — kurzer rechtlicher Hinweis für Blog-Beiträge.
 * Macht klar, dass es sich um persönliche Meinung & redaktionelle
 * Empfehlungen handelt, keine medizinische / professionelle Beratung.
 */
const BlogDisclaimer = ({ compact = false }) => {
  if (compact) {
    return (
      <p
        className="text-[11px] text-[#8B7355] mt-4 text-center italic px-3"
        data-testid="blog-disclaimer-compact"
      >
        Beiträge dienen der Unterhaltung & spiegeln die persönliche Sicht der Autorin wider –
        keine medizinische oder professionelle Beratung.
      </p>
    );
  }
  return (
    <div
      className="mt-12 p-4 bg-[#FAF5EE] border border-[#E8DCC8] text-xs text-[#6D5A47] leading-relaxed flex items-start gap-2"
      data-testid="blog-disclaimer"
    >
      <Info className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: '#C4A084' }} />
      <p>
        <strong className="text-[#5D4E3C]">Hinweis:</strong> Die Inhalte unseres Blogs
        dienen ausschließlich der allgemeinen Information und Unterhaltung. Sie geben die
        persönliche Sicht der Autorin wieder und ersetzen weder eine medizinische,
        therapeutische, rechtliche, finanzielle noch eine sonstige professionelle Beratung.
        Bei gesundheitlichen Beschwerden, allergischen Reaktionen oder anderen ernsten
        Fragestellungen wende dich bitte an eine qualifizierte Fachperson. Wir übernehmen
        keine Haftung für Anwendungen oder Entscheidungen, die auf den hier geteilten
        Tipps und Empfehlungen beruhen.
      </p>
    </div>
  );
};

export default BlogDisclaimer;
